// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PopUp_Wrapper__2UDYX","Container":"PopUp_Container__29Afr"};